module.exports = __webpack_public_path__ + "img/bg2.c15c5eb0.png";